<template>
  <div class="h-100 w-100 overflow-hidden">
    <audio ref="bgSound" loop>
      <source :src="baseUrl + '/cpr/Sound/' + bgSoundFile" type="audio/mpeg" />
    </audio>
    <audio ref="hbSound">
      <source :src="baseUrl + '/cpr/Sound/hb.mp3'" type="audio/mpeg" />
    </audio>

    <audio ref="hbSound2">
      <source :src="baseUrl + '/cpr/Sound/hb2.mp3'" type="audio/mpeg" />
    </audio>

    <div class="close-container">
      <CButton @click="onClose">
        <font-awesome-icon :icon="['fas', 'times']" />
      </CButton>
    </div>
    <div class="sound-container">
      <CButton v-if="bgSound" @click="onBGSoundPause">
        <font-awesome-icon :icon="['fas', 'volume-up']" />
      </CButton>
      <CButton v-else @click="onBGSoundPlay">
        <font-awesome-icon :icon="['fas', 'volume-mute']" />
      </CButton>
    </div>
    <!--:style="{ 'background-image': 'url(' + require('@/assets/images/CPR/' + mainImg) + ')' }"-->
    <div
      v-if="loaded"
      id="main-img"
      class="flex-container"
      :class="{ blur: !startSimulation || finishSimulation, zoom: zoom }"
    >
      <div
        id="main-img-child"
        :style="{
          'background-image': 'url(' + baseUrl + 'cpr/Image/' + mainImg + ')',
        }"
        :class="{ zoom: zoom }"
      ></div>
    </div>
    <div id="timer-container">
      <CRow>
        <CCol class="col-12">
          <Timer ref="timer" />
        </CCol>
      </CRow>
    </div>
    <div v-if="!startSimulation" class="option-container">
      <div>
        <h3 class="p-2">เลือกลำดับขั้นตอนการช่วยเหลือผู้ป่วย</h3>
        <div class="p-2">
          <div
            v-for="(item, index) in processing"
            :key="index"
            class="option m-1"
            @click.prevent="addOrder(index)"
          >
            <div class="thumb">
              <img :src="baseUrl + 'cpr/Icon/' + item.image + '.png'" />
              <a v-if="item.order != 0" class="active">{{ item.order }}</a>
              <a v-else>&nbsp;</a>
            </div>
            <div class="mt-2">{{ item.name }}</div>
            <div class="mt-2">{{ $helpers.translate(item.title, lang) }}</div>
          </div>
        </div>
      </div>
      <div v-if="this.tmpOrder.length == 0" class="row">
        <div class="text-center col-12">
          <button
            class="btn btn-primary"
            type="button"
            @click.prevent="onStart()"
          >
            ยืนยัน
          </button>
        </div>
      </div>
    </div>
    <ul id="process-icon" v-if="startSimulation">
      <li
        v-for="(item, index) in processing"
        :key="index"
        class="m-3"
        :class="{ active: activeProcess == item }"
      >
        <img :src="baseUrl + 'cpr/Icon/' + item.image + '.png'" />
      </li>
    </ul>
    <div id="restart-modal" v-if="finishSimulation">
      <div class="p-4 body">ต้องการทำการช่วยเหลือซ้ำหรือไม่</div>
      <div>
        <button
          type="button"
          class="btn btn-secondary m-4 w125"
          @click.prevent="onReset()"
        >
          <font-awesome-icon :icon="['fas', 'redo']" />&nbsp;ทำซ้ำ
        </button>
        <button
          type="button"
          class="btn btn-primary m-4 w125"
          @click.prevent="onFinish()"
        >
          <font-awesome-icon :icon="['fas', 'check']" />&nbsp;เสร็จสิ้น
        </button>
      </div>
    </div>
    <div id="question-container" class="event">
      <CRow class="choice m-0">
        <CCol v-for="(item, index) in question.choices" :key="index">
          <a @click.prevent="onSelect(item)" class="d-block w-100">{{
            item.text
          }}</a>
        </CCol>
      </CRow>
      <CRow class="m-0">
        <CCol class="body">{{ question.text }}</CCol>
      </CRow>
    </div>
    <div id="message" v-if="message != ''" class="event">
      <p>{{ message }}</p>
      <div class="text-right">
        <font-awesome-icon :icon="['fas', 'hand-point-up']" />&nbsp;
        <small>Click on an image to continue</small>
      </div>
    </div>
    <div
      id="event-container"
      class="event"
      v-if="Object.keys(eventIcon).length != 0"
    >
      <img :src="baseUrl + 'cpr/Icon/' + eventIcon.image" class="pulse" />
      <!--<img :src="require(`@/assets/images/CPR/E4/Event/${eventIcon.image}`)" class="pulse" />-->
    </div>
    <div
      id="cpr-icon-container"
      class="event"
      v-if="Object.keys(cprIcon).length != 0"
    >
      <img :src="baseUrl + 'cpr/Icon/' + cprIcon.image" />
      <!--<img :src="require(`@/assets/images/CPR/E4/Event/${cprIcon.image}`)" />-->
    </div>
    <div v-if="countdownModal" id="countdown-modal">
      <p>{{ countDown }}</p>
    </div>
    <div id="cpr-container" class="event">
      <!--------- Event component ----------------->
      <div
        v-if="this.previewCPR == true"
        id="cpr-preview-container"
        class="event text-center p-4"
      >
        <p>{{ $helpers.translate(cpr.description.text, "th") }}</p>
        <button
          type="button"
          class="btn btn-primary mt-2"
          @click="onStartCountDown"
        >
          Start Simulation
        </button>
      </div>
      <div
        v-if="
          this.cpr.question &&
          this.startCPR == false &&
          this.previewCPR == false
        "
        id="cpr-container-question"
      >
        <CRow class="choice m-0">
          <CCol v-for="(item, index) in this.cpr.question.choices" :key="index">
            <a @click.prevent="onSelectCPR(item)" class="d-block w-100">{{
              item.text
            }}</a>
          </CCol>
        </CRow>
        <div class="body w-100">{{ this.cpr.question.text }}</div>
      </div>
      <div
        v-else-if="this.startCPR == true && this.previewCPR == false"
        id="cpr-info"
      >
        <img :src="baseUrl + 'cpr/Image/Motion-Pulse.png'" />

        <div class="process"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Timer from "@/components/template/CPR/timer";
export default {
  name: "Simulation",
  components: {
    Timer,
  },
  data() {
    return {
      count: 0,
      data: [],
      lang: "th",
      loaded: false,
      mainImg: "",
      processing: [],
      finishSimulation: false,
      startSimulation: false,
      tmpOrder: [],
      activeProcess: [],
      tmpEventNum: 0,
      tmpProcessNum: 0,
      message: "",
      question: { text: "", choice: [] },
      cpr: { text: "", choice: [] },
      eventIcon: {},
      cprIcon: {},
      cprDown: 0,
      cprTimeCount: 0,
      cprResult: false,
      cprAll: 0,
      cprPos: 0,
      cprActionCount: 0,
      startCPR: false,
      previewCPR: false,
      answer: [],
      score: 0,
      maxScore: 0,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      bgSound: true,
      bgSoundFile: "CPR.mp3",
      zoom: false,
      countDown: 0,
      countdownModal: false,
      templateId: "",
      paticipationId: "",
      interactionId: "",
      timingId: "",
      knowledgeId: "",
      startTime: "",
      startSimtime: "",
      courseSection: 0,
      courseCode: "",
    };
  },
  computed: {
    ...mapGetters({
      templateContent: "template/getTemplateContent",
      loadingGetter: "template/loadingGetter",
      getTemplateCriteria: "template/getUserTemplate",
    }),
  },
  watch: {
    bgSoundFile: function (val) {
      this.$refs.bgSound.load();
      this.$refs.bgSound.play();
    },
    getTemplateCriteria: function (val) {
      val.data.condition.criteriaType.filter((item, index) => {
        if (
          this.$helpers.translate(item.criteria.name, "en") == "paticipation"
        ) {
          this.paticipationId = item.criteria._id;
        } else if (
          this.$helpers.translate(item.criteria.name, "en") == "interaction"
        ) {
          this.interactionId = item.criteria._id;
        } else if (
          this.$helpers.translate(item.criteria.name, "en") == "timing"
        ) {
          this.timingId = item.criteria._id;
        } else if (
          this.$helpers.translate(item.criteria.name, "en") == "knowledge"
        ) {
          this.knowledgeId = item.criteria._id;
        }
      });
    },
    templateContent: function (val) {
      this.data = val;
      this.loaded = true;
      this.templateId = val._id;

      this.mainImg = this.data.content.image[0].url;
      this.next = val.navigate.next.action;
      this.processing = this.data.content.process;
      this.processing.forEach((item, index) => {
        this.tmpOrder.push(index + 1);
      });
      this.jquery("#timer-container").fadeIn();
      this.$refs.timer.startTimer();
      this.courseSection = this.$store.getters['necessary/getUserCourseSection']
      this.$store.dispatch("template/createUserTemplateData", {
        code: this.courseCode,
        template: this.templateId,
        section: this.courseSection,
      });
    },
    loadingGetter: function (val) {
      this.$router.push("/CPR/summary/" + this.next);
    },
  },
  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },
  created() {
    this.startSimtime = Math.floor(new Date().getTime() / 1000);
    this.startTime = this.$helpers.getDateFormat();
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
  },
  beforeDestroy() {},
  methods: {
    onClose() {
      this.$router.push({
        path: "/CPR/preview/" + this.data.navigate.close.action,
      });
    },
    onBGSoundPlay() {
      this.$refs.bgSound.play();
      this.bgSound = true;
    },
    onBGSoundPause() {
      this.$refs.bgSound.pause();
      this.bgSound = false;
    },
    onHB2Sound() {
      this.$refs.hbSound2.pause();
      this.$refs.hbSound2.currentTime = 0;
      this.$refs.hbSound2.play();
    },
    onHBSound() {
      this.$refs.hbSound.pause();
      this.$refs.hbSound.currentTime = 0;
      this.$refs.hbSound.play();
    },
    onFinish() {
      const useTime =
        Math.floor(new Date().getTime() / 1000) - this.startSimtime;

      var timingScore = 0;
      /// calculate overall time ///

      var startRangeTime = 4 * 60;
      var endRangeTime = 5 * 60;
      if (useTime >= startRangeTime && useTime <= endRangeTime) {
        timingScore += 15;
      } else {
        var diffTime = 0;
        var minusScore = 0;
        if (useTime < startRangeTime) {
          diffTime = startRangeTime - useTime;
        } else if (useTime > endRangeTime) {
          diffTime = useTime - endRangeTime;
        }
        minusScore = Math.floor(diffTime / 30) * 0.5;
        timingScore += 15 - minusScore;
      }

      //// calculate cpr time score ////
      timingScore += (this.cprActionCount * 15) / 60;

      //// calculate quiz score ////
      const knowledgeScore = (this.score / this.maxScore) * 40;
      //////////////////////////////
      const userCriteria = {
        code: this.courseCode,
        template: this.templateId,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: [
          {
            criteria: this.paticipationId, // การวัดผลด้านต่างๆ
            val: 10,
          },
          {
            criteria: this.interactionId,
            val: 20,
          },
          {
            criteria: this.timingId,
            val: timingScore,
          },
          {
            criteria: this.knowledgeId,
            val: knowledgeScore,
          },
        ],
      };
      this.$store.dispatch("template/saveUserTemplateData", userCriteria);
    },
    onStartCountDown() {
      this.jquery("#cpr-container").hide();
      this.previewCPR = false;
      this.countdownModal = true;
      this.countDown = distance;
      var distance = 3;

      var x = setInterval(() => {
        this.countDown = distance;
        distance = distance - 1;

        if (distance < 0) {
          this.countdownModal = false;
          clearInterval(x);
          setTimeout(() => {
            this.jquery("#cpr-container").show();
            this.onStartCPR();
          }, 200);
        }
      }, 1000);
    },
    onStartCPR() {
      this.startCPR = true;
      this.previewCPR = false;

      this.cprTimeCount = 30;
      this.cprActionCount = 0;
      this.cprAll = 0;
      const containerWidth = this.jquery("#cpr-container").width();
      var width = 0;
      var count = 0;
      var countSec = 0;

      document.addEventListener("mousedown", this.onCPRDown);
      document.addEventListener("mouseup", this.onCPRUp);
      document.addEventListener("keydown", this.onCPRDown, false);
      document.addEventListener("keyup", this.onCPRUp, false);
      this.zoom = true;
      var y = setInterval(() => {
        countSec += 1;

        if (this.cprTimeCount > 0) {
          count += 1;
          width = (count * containerWidth) / 3000;
          this.cprPos = width;
          this.jquery("#cpr-info .process").css("width", `${width}px`);
        }
        if (countSec == 100) {
          this.cprTimeCount -= 1;
          countSec = 0;
        }
        if (this.cprTimeCount == 0) {
          clearInterval(y);
          document.removeEventListener("mousedown", this.onCPRDown, false);
          document.removeEventListener("mouseup", this.onCPRUp, false);
          document.removeEventListener("keydown", this.onCPRDown, false);
          document.removeEventListener("keyup", this.onCPRUp, false);
          this.zoom = false;
          this.jquery("#cpr-icon-container").hide();
          this.jquery("#cpr-container").fadeOut(1000, () => {
            this.changeEvent();
          });
          this.bgSoundFile = "CPR.mp3";
        }
        if (
          (countSec > 0 && countSec < 10) ||
          (countSec > 50 && countSec < 60)
        ) {
          this.jquery("#cpr-info").addClass("cpr-light");
          this.onHBSound();
          if (this.cprTimeCount < 15 && this.cprActionCount < 30) {
            //change sound
            //this.onHB2Sound();
            this.bgSoundFile = "hb2.mp3";
            //this.$refs.bgSound.load();
          }
          this.cprResult = true;
        } else {
          this.jquery("#cpr-info").removeClass("cpr-light");
          this.cprResult = false;
        }
        this.cprAll++;
      }, 10);
    },
    onSelectCPR(item) {
      this.previewCPR = true;
      this.cprIcon = item.animation;
      this.answer.push({
        question: this.question.text,
        answer: item.text,
        correct: item.answer,
      });
    },
    onCPRDown(event) {
      if (event.code === "Space" || event.which == 1) {
        if (this.cprDown == 0) {
          window.event.preventDefault();
          if (this.cprResult) {
            this.cprActionCount += 1;
            this.jquery("#cpr-info").append(
              "<div class='pulse' style='opacity:0.5;position: absolute;width: 10px;height: 10px;background: #0F0;top: 50%;margin-top: -10px;border-radius: 50%;z-index: 9;left:" +
                this.cprPos +
                "px'></div>"
            );
          } else {
            this.jquery("#cpr-info").append(
              "<div class='pulse' style='opacity:0.5;position: absolute;width: 10px;height: 10px;background: #F00;top: 50%;margin-top: -10px;border-radius: 50%;z-index: 9;left:" +
                this.cprPos +
                "px'></div>"
            );
          }
          this.jquery("#cpr-icon-container").show();
          this.cprDown = 1;
        }
      }
    },
    onCPRUp(event) {
      if (event.code === "Space" || event.which == 1) {
        this.cprDown = 0;
        this.jquery("#cpr-icon-container").hide();
      }
    },
    onSelect(item) {
      /* ==== tmp answer ==== */
      this.answer.push({
        question: this.question.text,
        answer: item.text,
        correct: item.answer,
      });
      /* ==================== */
      this.score += item.score;
      this.maxScore += 1;
      this.jquery("#question-container").fadeOut();
      if (item.animation) {
        this.eventIcon = item.animation;
        this.jquery("#event-container").fadeIn();
        setTimeout(() => {
          this.jquery("#event-container").fadeOut();
          this.changeEvent();
        }, 3000);
      } else {
        this.changeEvent();
      }
    },
    onStart() {
      this.processing.sort((a, b) => (a.order > b.order ? 1 : -1));
      this.tmpProcessNum = 0;
      this.changeEvent();
      this.startSimulation = true;
      this.onBGSoundPlay();
    },
    onReset() {
      this.$router.go();
    },
    changeEvent() {
      if (this.processing[this.tmpProcessNum]) {
        this.activeProcess = this.processing[this.tmpProcessNum];
        this.questions = [];
        this.message = "";

        if (this.activeProcess.event[this.tmpEventNum].type == "message") {
          this.message = this.activeProcess.event[this.tmpEventNum].message;
          document
            .getElementById("main-img")
            .addEventListener("click", this.changeEvent);
        } else if (
          this.activeProcess.event[this.tmpEventNum].type == "question"
        ) {
          this.question = this.activeProcess.event[this.tmpEventNum].question;
          this.jquery("#question-container").fadeIn();
          document
            .getElementById("main-img")
            .removeEventListener("click", this.changeEvent);
          this.message = "";
        } else if (this.activeProcess.event[this.tmpEventNum].type == "CPR") {
          // display cpr preview //
          document
            .getElementById("main-img")
            .removeEventListener("click", this.changeEvent);
          this.cpr = this.activeProcess.event[this.tmpEventNum];
          document
            .getElementById("main-img")
            .removeEventListener("click", this.changeEvent);
          this.cpr = this.activeProcess.event[this.tmpEventNum];
          this.jquery("#cpr-container").fadeIn();
        }
        this.tmpEventNum += 1;
        if (this.activeProcess.event.length == this.tmpEventNum) {
          this.tmpProcessNum += 1;
          this.tmpEventNum = 0;
        }
        //alert(this.activeProcess.zoomImg)
        this.zoom = this.activeProcess.zoomImg;
      } else {
        this.jquery(".event").fadeOut();
        document
          .getElementById("main-img")
          .removeEventListener("click", this.changeEvent);
        this.$refs.timer.onPause();
        this.finishSimulation = true;
        this.onBGSoundPause();
        //this.$store.dispatch("progress/setUserProgress", this.answer);
      }
    },
    addOrder(i) {
      var min = 0;
      if (this.processing[i].order == 0) {
        min = Math.min(...this.tmpOrder);
        var index = this.tmpOrder.indexOf(min);
        if (index > -1) {
          this.tmpOrder.splice(index, 1);
        }
        this.processing[i].order = min;
      } else {
        this.tmpOrder.push(this.processing[i].order);
        this.processing[i].order = 0;
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/scss/CPR/style.scss";
body {
  background-color: #f3f3f3 !important;
}
.flex-container {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.blur {
  filter: blur(3px);
  -webkit-filter: blur(3px);
}
#restart-modal {
  position: absolute;
  width: 380px;
  height: auto;
  top: 50%;
  left: 50%;
  margin-left: -190px;
  margin-top: -60px;
  text-align: center;
}
#restart-modal .body {
  border-radius: 20px;
  background-color: hsla(0, 0%, 92.2%, 0.3);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
  font-size: 24px;
  min-height: 100px;
}
#countdown-modal {
  position: absolute;
  width: 100px;
  height: 100px;
  font-size: 4rem;
  z-index: 99;
  color: #fff;
  top: 50%;
  left: 50%;
  margin-left: -50px;
  margin-top: -50px;
  text-align: center;
}
.option-container {
  position: absolute;
  width: 360px;
  height: 360px;
  top: 50%;
  left: 50%;
  margin-left: -180px;
  margin-top: -180px;
  text-align: center;
  border-radius: 20px;
  background-color: hsla(0, 0%, 92.2%, 0.3);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
}
.option-container .option {
  vertical-align: text-bottom;
  display: inline-block;
  width: 160px;
  height: 150px;
  text-align: center;
}
.option-container .option .thumb {
  width: 80px;
  height: 80px;
  display: block;
  margin: 0 auto;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  position: relative;
}
.option-container .option .thumb a {
  position: absolute;
  border: 1px solid #000;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  top: 5px;
  right: 5px;
  line-height: 20px;
  transition: all 0.5s ease;
}
.hide {
  display: none;
}
.option-container .option .thumb img {
  width: 100%;
  height: 100%;
}
.option-container .option .thumb .active {
  background-color: #ff2121;
  border: none;
  color: #fff;
}
.option-container h3 {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  font-size: 16px;
  text-align: center;
  background: #e2e2e2;
  color: #000;
}
.sound-container {
  text-align: center;
  position: absolute;
  bottom: 15%;
  right: 5%;
  z-index: 9;
  /*background: transparent
    linear-gradient(139deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(139deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;*/
  background: #f3f3f3;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  opacity: 0.8;
  border-radius: 50%;
}
.close-container {
  text-align: center;
  position: absolute;
  top: 15%;
  right: 5%;
  z-index: 9;
  /*background: transparent
    linear-gradient(139deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(139deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;*/
  background: #f3f3f3;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  opacity: 0.8;
  border-radius: 50%;
}
#timer-container {
  position: absolute;
  width: 300px;
  text-align: center;
  top: 10%;
  left: 50%;
  margin-left: -150px;
  color: #fff;
  font-size: 20px;
  display: none;
}
#main-img {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
#main-img-child {
  width: 100%;
  min-height: 100vh;
  background-color: #103b29;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  transition: all 0.5s ease;
}
#process-icon {
  position: absolute;
  z-index: 9;
  left: 10px;
  bottom: 10px;
  list-style: none;
  /*transform: rotate(180deg);*/
}
#process-icon li {
  /*transform: rotate(-180deg);*/
}
#process-icon li img {
  width: 60px;
  -webkit-filter: brightness(10%); /* Safari 6.0 - 9.0 */
  filter: brightness(10%);
  opacity: 0.4;
  transition: all 0.5s ease;
}
#process-icon .active img {
  width: 100px !important;
  -webkit-filter: brightness(100%); /* Safari 6.0 - 9.0 */
  filter: brightness(100%);
  opacity: 1;
}
#message {
  color: #fff;
  position: absolute;
  bottom: 10%;
  width: 60%;
  margin-left: -30%;
  left: 50%;
  text-align: center;
  font-size: 24px;
  z-index: 9;
}
#message p {
  display: inline-block;
  width: auto;
  padding: 5px 15px 5px 15px;
  -webkit-box-shadow: inset 0px 0px 8px 5px rgba(227, 227, 227, 0.63);
  box-shadow: inset 0px 0px 8px 5px rgba(227, 227, 227, 0.63);
  padding: 10px;
}
#cpr-preview-container {
  position: absolute;
  bottom: 20%;
  left: 50%;
  width: 60%;
  margin-left: -30%;
  z-index: 9;
}
#cpr-preview-container p {
  padding: 10px;
  border-radius: 10px;
  background-color: hsla(0, 0%, 92.2%, 0.9);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
  text-align: center;
  font-size: 20px;
}
#question-container {
  position: absolute;
  bottom: 20%;
  left: 50%;
  width: 60%;
  margin-left: -30%;
  z-index: 9;
  display: none;
}
#question-container .body,
#cpr-container-question .body {
  padding: 10px;
  border-radius: 0 0 5px 5px;
  background-color: hsla(0, 0%, 92.2%, 0.9);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  opacity: 1;
  backdrop-filter: blur(10px);
  text-align: center;
  font-size: 25px;
}
#cpr-container-question .choice div,
#question-container .choice div {
  background-color: hsla(0, 0%, 92.2%, 0.8);
  -webkit-box-shadow: 0 10px 80px rgba(0, 0, 0, 0.05);
  border-radius: 5px 5px 0 0;
  padding: 10px;
  font-size: 18px;
  text-align: left;
  cursor: pointer;
  transition: all 0.5s;
}
.hide-answer {
  margin-top: -100% !important;
  padding: 0 !important;
}
#cpr-container-question .choice div a,
#question-container .choice div a {
  width: 100%;
  height: 100%;
}
#question-container .choice div:hover,
#cpr-container .choice div:hover {
  background-color: hsla(0, 0%, 92.2%, 0.9);
}
#cpr-container-question .choice div:not(:last-child),
#question-container .choice div:not(:last-child) {
  margin-right: 3px;
}
#cpr-icon-container {
  display: none;
  border-radius: 50%;
  animation: cpr-pulse 0.3s ease-in;
  width: 200px;
  height: 200px;
  padding: 0;
  position: absolute;
  z-index: 999;
  right: 15%;
  top: 20%;
}
#event-container {
  position: absolute;
  width: 200px;
  height: 200px;
  z-index: 999;
  right: 15%;
  top: 20%;
}
.zoom {
  transform: scale(1.5);
}
#cpr-icon-container img,
#event-container img {
  width: 100%;
  height: 100%;
  opacity: 0.9;
}
.pulse {
  animation: pulse 1s infinite;
  margin: 0 auto;
  display: table;
  animation-direction: alternate;
  -webkit-animation-name: pulse;
  animation-name: pulse;
}
#cpr-info {
  color: #fff;
  height: 150px;
  position: relative;
  border: 1px solid #fff;
  background: #000;
  opacity: 0.8;
}
#cpr-info img {
  width: 100%;
  height: 100%;
}
.cpr-light {
  -webkit-box-shadow: 0px 0px 51px 5px rgba(83, 78, 237, 1);
  -moz-box-shadow: 0px 0px 51px 5px rgba(83, 78, 237, 1);
  box-shadow: 0px 0px 51px 5px rgba(83, 78, 237, 1);
  border: 1px solid #534eed !important;
}
#cpr-info .process {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border: none;
  opacity: 0.8;
  -webkit-box-shadow: inset 0px 0px 30px 0px rgba(255, 255, 255, 1);
  -moz-box-shadow: inset 0px 0px 30px 0px rgba(255, 255, 255, 1);
  box-shadow: inset 0px 0px 30px 0px rgba(255, 255, 255, 1);
  border-right: 2px solid #efefef;
  width: 0;
  /*transition: all 0.5s ease;*/
}

#cpr-container {
  position: absolute;
  bottom: 5%;
  left: 20%;
  right: 20%;
  height: 200px;
  z-index: 9;
  display: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes cpr-pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
</style>